import { colors } from '@omilia/theme';
import { Resizable } from 're-resizable';
import styled, { css } from 'styled-components';
import { getThemeProp } from 'styles/theme';

export const maxWidth375 = css`
  @media (max-width: 375px) {
    width: calc(100% - 20px) !important;
    right: 10px;
  }
`;

export const bottomRight = css`
  bottom: 10px;
  right: 10px;
`;

export const getChatStyle = css`
  border-radius: 24px;
  bottom: 30px;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  font: 14px ${getThemeProp('fontFamily')};
  max-height: calc(100% - 30px);
  overflow: visible;
  right: 30px;
  width: 376px;
  z-index: 999;
`;

export const mediaQueries = css`
  ${maxWidth375}

  @media (max-width: 550px) {
    ${bottomRight}
  }

  @media (max-height: 500px) {
    max-width: calc(100% - 20px) !important;
    width: calc(100vw - 20px) !important;

    ${bottomRight}
  }

  @media (max-height: 600px) {
    height: calc(100% - 20px) !important;
    max-height: unset;

    ${bottomRight}
  }
`;

export const SResizableContainer = styled(Resizable)`
  background-color: ${getThemeProp('primaryColor')};
  overflow: hidden;
  padding-top: 5px;
  ${getChatStyle}
  ${mediaQueries}
`;

export const SFormContainer = styled.div`
  background-color: white;
  height: 100%;
  overflow: auto;
`;

export const SDropzone = styled.div`
  align-items: center;
  background-color: ${colors.COLOR_WHITE};
  border-radius: 24px;
  border: 2px dashed ${colors.COLOR_DEEP_PURPLE_800};
  bottom: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: absolute;
  top: 64px;
  width: 100%;
  z-index: 1;
`;

export const SDropzoneText = styled.span`
  color: ${colors.COLOR_DEEP_PURPLE_800};
  font-size: 18px;
  margin-top: 16px;
`;
